import React, { useEffect } from 'react';
import { useFcmToken } from '@/hooks/use.fcm.token';
import { Platform } from 'react-native';
import { useUser } from '@/hooks/use.user';
import { getAppVersion } from '../../utils';
import { NotificationsHandler } from './notification.handler';
import { useRenewAuth } from '@/apis/auth';

function BaseNotificationsProvider({ children }: any) {
  const { fcmToken } = useFcmToken();
  const { authenticated } = useUser();
  const { mutate: renewAuth } = useRenewAuth();
  const { user } = useUser();

  useEffect(() => {
    if (!user) {
      return;
    }
    if (!fcmToken && !user.fcmToken) {
      return;
    }
    if (user.fcmToken === fcmToken) {
      return;
    }
    renewAuth({ body: { fcmToken, os: Platform.OS, version: getAppVersion() } });
  }, [user, user?.fcmToken, fcmToken, renewAuth]);

  useEffect(() => {
    if (authenticated) {
      renewAuth({ body: { fcmToken, os: Platform.OS, version: getAppVersion() } });
    }
  }, [authenticated, renewAuth]); // don't include fcmToken here

  return <NotificationsHandler>{children}</NotificationsHandler>;
}

export const NotificationsProvider = React.memo(BaseNotificationsProvider);
